import __request__ from "routing/request";
export function create(inputId, JSONbody) {
  return __request__("POST", `/system/inputs/${inputId}/staticfields`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(key, inputId) {
  return __request__("DELETE", `/system/inputs/${inputId}/staticfields/${key}`, null, {}, {
    "Accept": ["application/json"]
  });
}
